import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import FacilitiesTable from "../../components/FacilitiesTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { getFacilitiesDetails, saveFacilities } from "../../api/dataCapture";
import { resetSelectedFacility, setFacilitiesDetails, setIsUpdatedFacility } from "../../redux/reducers/dataCaptures";
import AddFacilitiesForm from "../AddFacilitiesForm";
import FacilityDetailPage from "../FacilityDetailPage";

const FacilityDetails = () => {
    const [addFactilities, setAddFactilities] = React.useState(false);
    const dispatch = useDispatch();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const selectedFacility = useSelector((state:any) => state.dataCaptures.selectedFacility);
    const facilitiesDetails = useSelector((state:any) => state.dataCaptures.facilitiesDetails);
    const isUpdatedFacility = useSelector((state:any) => state.dataCaptures.isUpdatedFacility);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

    useEffect(() => {
        const fetchFacilitiesDetails = async () => {
            const response = await getFacilitiesDetails({clubId: clubDetails.id, isPast: false});
            dispatch(setFacilitiesDetails(response));
        }
        fetchFacilitiesDetails();
    }, []);

    const handleFacilityDetailsClose = async () => {
        if (isUpdatedFacility) {
            const updatedList = facilitiesDetails?.map((item:any) => item?.id == selectedFacility?.id ? selectedFacility : item);
            const response = await saveFacilities({clubId: clubDetails?.id, data: updatedList});
            dispatch(setFacilitiesDetails(response));
            const boolean:any = false;
            dispatch(setIsUpdatedFacility(boolean));
        } dispatch(resetSelectedFacility());
    }

    const createNewFacility = (newPlayer:any) => {
        const updatedData = [...facilitiesDetails, newPlayer];
        saveFacilities({clubId: clubDetails?.id, data: updatedData})
        .then((res:any) => {
        dispatch(setFacilitiesDetails(res));
        });
        setAddFactilities(false);
    }

    return (
        <Box>
            {!isAdmin && addFactilities && <AddFacilitiesForm onCancelClick={() => setAddFactilities(false)} onCreateClick={createNewFacility}/>}
            <FacilityDetailPage isOpen={selectedFacility && Object.keys(selectedFacility)?.length > 0} 
            handleClose={handleFacilityDetailsClose} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography className='standardsHeading uppercase'>facilities</Typography>
                {
                    !isAdmin &&
                    <Button className='smallButton' sx={{ float: 'right' }} 
                    disableElevation 
                    disabled={addFactilities} 
                    variant='contained' size='small' 
                    onClick={() => {setAddFactilities(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                        {'Add facilities'}
                    </Button>
                }
            </Box>
            <FacilitiesTable addData={addFactilities} />
        </Box>
    )
}

export default FacilityDetails;